<script>
import Joi from '@hapi/joi'
import moment from 'moment'
import { ActionBar, ActionBarTitle } from '@/components/ui/action-bar'
import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { useLoading } from '@/use/loading'
import { back } from '@/utils/navigation'
import { Notification } from 'element-ui'
import { UserService } from '@/services'

const clone = require('rfdc')()

const Form = () => import('../components/Form')

let origForm = null

export default {
  data() {
    return {
      form: {
        profilePicture: null,
        firstName: '',
        lastName: '',
        gender: 'U',
        birthDate: null,
        idCardNo: '',
        idCardAttachment: null,
        username: '',
        password: '',
        telNo: '',
        email: '',
        address: '',
        subdistrict: null,
        district: '',
        province: '',
        postalCode: ''
      },
      editing: false
    }
  },

  async beforeRouteEnter(to, from, next) {
    const { id } = to.params

    const loading = useLoading()

    try {
      const {
        data: { result }
      } = await UserService.get(id)

      next(vm => {
        vm.form = {
          profilePicture: result.image ? { src: result.image.medium } : null,
          firstName: result.first_name,
          lastName: result.last_name,
          gender: result.gender,
          birthDate: result.birthdate ? new Date(result.birthdate) : null,
          idCardNo: result.id_card_number,
          idCardAttachment: result.id_card_image
            ? { url: result.id_card_image.large }
            : null,
          username: result.username,
          password: '',
          telNo: result.phone,
          email: result.email,
          address: result.address,
          subdistrict: result.subdistrict
            ? {
                id: result.subdistrict.subdistrict.id,
                text: result.subdistrict.subdistrict.name_th
              }
            : null,
          district: result.subdistrict
            ? result.subdistrict.district.name_th
            : '',
          province: result.subdistrict
            ? result.subdistrict.province.name_th
            : '',
          postalCode: result.subdistrict
            ? result.subdistrict.subdistrict.zip_code
            : ''
        }
      })
    } catch (e) {
      Notification.error(e.message)
      next(false)
    } finally {
      loading.close()
    }
  },

  methods: {
    dismiss() {
      back({ name: 'Employee' })
    },

    cancel() {
      this.form = origForm

      this.editing = false
    },

    async save() {
      const validate = () => {
        const schema = Joi.object({
          firstName: Joi.string(),
          idCardAttachment: Joi.object(),
          username: Joi.string(),
          telNo: Joi.string()
        })

        return schema.validateAsync(this.form, { allowUnknown: true })
      }

      const sendData = () => {
        const data = (data => {
          const formData = new FormData()

          Object.keys(data).forEach(k => {
            if (typeof data[k] === 'string' && !data[k]) return
            formData.set(k, data[k])
          })

          return formData
        })({
          username: this.form.username,
          password: this.form.password,
          is_stuff: false,
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          ...(this.form.profilePicture &&
            this.form.profilePicture.file && {
              image: this.form.profilePicture.file
            }),
          email: this.form.email,
          gender: this.form.gender,
          birthdate: this.form.birthDate
            ? moment(this.form.birthDate).format('Y-MM-DD')
            : '',
          id_card_number: this.form.idCardNo,
          ...(this.form.idCardAttachment &&
            this.form.idCardAttachment.file && {
              id_card_image: this.form.idCardAttachment.file
            }),
          phone: this.form.telNo,
          address: this.form.address,
          subdistrict: this.form.subdistrict ? this.form.subdistrict.id : ''
        })

        return UserService.update(this.$route.params.id, data)
      }

      try {
        await validate()

        const loading = useLoading()

        try {
          await sendData()

          this.$notify.success('บันทึกเรียบร้อยแล้ว')

          this.$router.push({ name: 'Employee' })
        } catch (e) {
          this.$notify.error(e.message)
        } finally {
          loading.close()
        }
      } catch (e) {
        this.$message.warning('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
      }
    },

    edit() {
      origForm = clone(this.form)

      this.editing = true
    },

    handleChange(data) {
      this.form = data
    }
  },

  render() {
    return (
      <div>
        <ActionBar dismissible={!this.editing} onDismiss={this.dismiss}>
          {/*this.editing ? (
            [
              <ActionBarButton slot="action" onClick={this.cancel}>
                ยกเลิก
              </ActionBarButton>,
              <ActionBarButton slot="action" type="primary" onClick={this.save}>
                บันทึก
              </ActionBarButton>
            ]
          ) : (
            <ActionBarButton slot="action" onClick={this.edit}>
              แก้ไข
            </ActionBarButton>
          )*/}
          <ActionBarTitle>
            {this.editing ? 'แก้ไขพนักงาน' : 'รายละเอียดพนักงาน'}
          </ActionBarTitle>
        </ActionBar>
        <PageContainer>
          <AppContainer>
            <Form
              data={this.form}
              readonly={!this.editing}
              optionalFields={['password']}
              onChange={this.handleChange}
            />
          </AppContainer>
        </PageContainer>
      </div>
    )
  }
}
</script>
